// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MatrizControlED_container__GDeWU {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.MatrizControlED_container__GDeWU .MatrizControlED_header__NM1-2 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.MatrizControlED_container__GDeWU .MatrizControlED_header__NM1-2 .MatrizControlED_titleContainer__hLAka {
  animation: MatrizControlED_toright__tNd\\+p 0.3s;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.MatrizControlED_container__GDeWU .MatrizControlED_header__NM1-2 .MatrizControlED_titleContainer__hLAka h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.MatrizControlED_container__GDeWU .MatrizControlED_filters__x\\+cHH {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.MatrizControlED_container__GDeWU .MatrizControlED_filters__x\\+cHH .MatrizControlED_item__zGms9 {
  animation: MatrizControlED_init__Grwsk 0.5s both;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.MatrizControlED_container__GDeWU .MatrizControlED_filters__x\\+cHH .MatrizControlED_init1__b-wqu {
  animation: MatrizControlED_init__Grwsk 0.5s 0.2s both;
}
.MatrizControlED_container__GDeWU .MatrizControlED_filters__x\\+cHH .MatrizControlED_init2__jX3cW {
  animation: MatrizControlED_init__Grwsk 0.5s 0.4s both;
}
.MatrizControlED_container__GDeWU .MatrizControlED_filters__x\\+cHH .MatrizControlED_init3__lKqGr {
  animation: MatrizControlED_init__Grwsk 0.5s 0.6s both;
}

.MatrizControlED_container__GDeWU .MatrizControlED_loader__quHsA {
  animation: MatrizControlED_init__Grwsk 0.5s both;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.MatrizControlED_container__GDeWU .MatrizControlED_loader__quHsA p {
  font-size: 1.8rem;
  font-weight: 300;
}

.MatrizControlED_container__GDeWU .MatrizControlED_data__6QW5p .MatrizControlED_tableContainer__V3ZdA {
  max-width: 100%;
  animation: MatrizControlED_toleft__SHPCS 0.3s both;
  border-radius: 5px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.MatrizControlED_container__GDeWU .MatrizControlED_data__6QW5p .MatrizControlED_tableContainer__V3ZdA .MatrizControlED_tableHeader__kBO1T {
  font-size: 0.9rem;
  font-weight: 500;
}

.MatrizControlED_container__GDeWU .MatrizControlED_options__MVQ0c {
  animation: MatrizControlED_toright__tNd\\+p 0.5s 1s both;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.MatrizControlED_container__GDeWU .MatrizControlED_options__MVQ0c p {
  margin: 0 0 0 10px;
  text-transform: capitalize;
  font-weight: 300;
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_checkboxes__tWd3n {
  overflow-y: scroll;
  max-height: 400px;
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_check__KQhOu {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 11vh;
  margin-bottom: 5px;
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_check__KQhOu .MatrizControlED_dataGame__-vjqv {
  width: 95%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_check__KQhOu .MatrizControlED_dataGame__-vjqv .MatrizControlED_imgcontainer__CKPGZ {
  width: 4rem;
  height: 4rem;
  border-radius: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_check__KQhOu .MatrizControlED_dataGame__-vjqv .MatrizControlED_imgcontainer__CKPGZ .MatrizControlED_checkImg__zmpa- {
  transition: 0.3s;
  font-size: 3.5rem;
  position: absolute;
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_check__KQhOu .MatrizControlED_dataGame__-vjqv .MatrizControlED_imgcontainer__CKPGZ img {
  transition: 0.3s;
  width: 3.9rem;
  height: 3.9rem;
  object-fit: scale-down;
  border-radius: 100%;
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_check__KQhOu .MatrizControlED_borderB__negAb {
  margin-top: 5px;
  opacity: 0.7;
  transition: 0.3s;
  height: 1px;
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_check__KQhOu:hover .MatrizControlED_borderB__negAb {
  transition: 0.3s;
  width: 95%;
}

.MatrizControlED_container__GDeWU .MatrizControlED_form__PLuPr .MatrizControlED_check__KQhOu .MatrizControlED_dataGame__-vjqv p {
  font-size: 1.2rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
  margin-left: 10px;
  text-transform: capitalize;
}

@keyframes MatrizControlED_init__Grwsk {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes MatrizControlED_toright__tNd\\+p {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes MatrizControlED_toleft__SHPCS {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media print {
  @page {
    size: landscape;
    margin: 50px 0 50px;
    quotes: none;
    visibility: visible;
  }

  .MatrizControlED_container__GDeWU .MatrizControlED_header__NM1-2 {
    display: none !important;
  }

  .MatrizControlED_container__GDeWU .MatrizControlED_filters__x\\+cHH {
    display: none !important;
  }

  .MatrizControlED_container__GDeWU .MatrizControlED_options__MVQ0c {
    display: none !important;
  }

  .MatrizControlED_container__GDeWU .MatrizControlED_data__6QW5p {
    min-width: 99%;
  }

  .MatrizControlED_container__GDeWU .MatrizControlED_data__6QW5p .MatrizControlED_tableContainer__V3ZdA {
    box-shadow: none;
    border-radius: 0;
  }

  .MatrizControlED_tableTitle__EUObC {
    color: black !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/MatrizControlED/MatrizControlED.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+CAAuB;EACvB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gDAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qDAA8B;AAChC;AACA;EACE,qDAA8B;AAChC;AACA;EACE,qDAA8B;AAChC;;AAEA;EACE,gDAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kDAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uDAA+B;EAC/B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: toright 0.3s;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .filters .item {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.container .filters .init1 {\n  animation: init 0.5s 0.2s both;\n}\n.container .filters .init2 {\n  animation: init 0.5s 0.4s both;\n}\n.container .filters .init3 {\n  animation: init 0.5s 0.6s both;\n}\n\n.container .loader {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.container .loader p {\n  font-size: 1.8rem;\n  font-weight: 300;\n}\n\n.container .data .tableContainer {\n  max-width: 100%;\n  animation: toleft 0.3s both;\n  border-radius: 5px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .tableHeader {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.container .options {\n  animation: toright 0.5s 1s both;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.container .options p {\n  margin: 0 0 0 10px;\n  text-transform: capitalize;\n  font-weight: 300;\n}\n\n.container .form .checkboxes {\n  overflow-y: scroll;\n  max-height: 400px;\n}\n\n.container .form .check {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 11vh;\n  margin-bottom: 5px;\n}\n\n.container .form .check .dataGame {\n  width: 95%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .form .check .dataGame .imgcontainer {\n  width: 4rem;\n  height: 4rem;\n  border-radius: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .form .check .dataGame .imgcontainer .checkImg {\n  transition: 0.3s;\n  font-size: 3.5rem;\n  position: absolute;\n}\n\n.container .form .check .dataGame .imgcontainer img {\n  transition: 0.3s;\n  width: 3.9rem;\n  height: 3.9rem;\n  object-fit: scale-down;\n  border-radius: 100%;\n}\n\n.container .form .check .borderB {\n  margin-top: 5px;\n  opacity: 0.7;\n  transition: 0.3s;\n  height: 1px;\n}\n\n.container .form .check:hover .borderB {\n  transition: 0.3s;\n  width: 95%;\n}\n\n.container .form .check .dataGame p {\n  font-size: 1.2rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n  margin-left: 10px;\n  text-transform: capitalize;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toright {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toleft {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media print {\n  @page {\n    size: landscape;\n    margin: 50px 0 50px;\n    quotes: none;\n    visibility: visible;\n  }\n\n  .container .header {\n    display: none !important;\n  }\n\n  .container .filters {\n    display: none !important;\n  }\n\n  .container .options {\n    display: none !important;\n  }\n\n  .container .data {\n    min-width: 99%;\n  }\n\n  .container .data .tableContainer {\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  .tableTitle {\n    color: black !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MatrizControlED_container__GDeWU`,
	"header": `MatrizControlED_header__NM1-2`,
	"titleContainer": `MatrizControlED_titleContainer__hLAka`,
	"toright": `MatrizControlED_toright__tNd+p`,
	"filters": `MatrizControlED_filters__x+cHH`,
	"item": `MatrizControlED_item__zGms9`,
	"init": `MatrizControlED_init__Grwsk`,
	"init1": `MatrizControlED_init1__b-wqu`,
	"init2": `MatrizControlED_init2__jX3cW`,
	"init3": `MatrizControlED_init3__lKqGr`,
	"loader": `MatrizControlED_loader__quHsA`,
	"data": `MatrizControlED_data__6QW5p`,
	"tableContainer": `MatrizControlED_tableContainer__V3ZdA`,
	"toleft": `MatrizControlED_toleft__SHPCS`,
	"tableHeader": `MatrizControlED_tableHeader__kBO1T`,
	"options": `MatrizControlED_options__MVQ0c`,
	"form": `MatrizControlED_form__PLuPr`,
	"checkboxes": `MatrizControlED_checkboxes__tWd3n`,
	"check": `MatrizControlED_check__KQhOu`,
	"dataGame": `MatrizControlED_dataGame__-vjqv`,
	"imgcontainer": `MatrizControlED_imgcontainer__CKPGZ`,
	"checkImg": `MatrizControlED_checkImg__zmpa-`,
	"borderB": `MatrizControlED_borderB__negAb`,
	"tableTitle": `MatrizControlED_tableTitle__EUObC`
};
export default ___CSS_LOADER_EXPORT___;
